import { useTheme, type PaletteMode } from "@mui/material/styles";

/**
 * Adds Metabase's `theme=night` display option to a signed embed URL in dark
 * mode. Display options live in the URL fragment, outside the signed token, so
 * they can be set here without the backend re-signing. An empty URL is
 * returned as-is so the iframe stays blank until the real URL loads.
 *
 * Dark mode also turns off `bordered`: Metabase's bordered card has rounded
 * corners with a light backdrop outside them, which shows as white wedges
 * against the dark page.
 */
export const withMetabaseTheme = (url: string, mode: PaletteMode): string => {
  if (!url || mode !== "dark") return url;
  const borderless = url.replace("bordered=true", "bordered=false");
  return `${borderless}${borderless.includes("#") ? "&" : "#"}theme=night`;
};

export const useMetabaseEmbedUrl = (url: string): string =>
  withMetabaseTheme(url, useTheme().palette.mode);
